import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {mb} from "@pg-design/helpers-css";
import {FaqSection, IFaqQuestion} from "@pg-mono/faq";
import {monthWhenVerbose, priceFormat, priceM2Format} from "@pg-mono/string-utils";

import {IRPStore} from "../../../app/rp_reducer";
import {calculateAvgPrices} from "../utils/calculate_avg_prices";
import {cityNameWhere, cityPronounWhere} from "../utils/city_name_declination_utils";
import {getCitiesData} from "../utils/get_cities_data";
import {calculatePercent, getPercentMeaning, getPercentMoreLess} from "../utils/percents_handling_helpers";

export const PricesGeneralFAQ = () => {
    const faq = useSelector((store: IRPStore) => store.faq.data);
    const citiesSummaryData = getCitiesData();

    const cheapestCities = citiesSummaryData && [...citiesSummaryData].sort((prev, next) => prev.avgPriceM2 - next.avgPriceM2);
    const expensiveCities = citiesSummaryData && [...citiesSummaryData].sort((prev, next) => next.avgPriceM2 - prev.avgPriceM2);
    const date = new Date((citiesSummaryData && citiesSummaryData[0].date) || "");
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const {generalAvgPrice, generalAvgM2Price, generalOldAvgM2Price} = calculateAvgPrices(citiesSummaryData);
    const priceM2Percent = calculatePercent(generalOldAvgM2Price, generalAvgM2Price);
    const pricePercent = calculatePercent(generalOldAvgM2Price, generalAvgM2Price);

    const genericFaq: IFaqQuestion[] = useMemo(() => {
        const answers = [
            `W ${monthWhenVerbose(month)} ${year} średnia cena za m2 wynosi ${priceM2Format(generalAvgM2Price)}. To o ${Math.abs(priceM2Percent)}% ${getPercentMoreLess(priceM2Percent)} niż w ubiegłych roku. Średnia ofertowa cena mieszkania w Polsce wynosi aktualnie ${priceFormat(generalAvgPrice)}, to oznacza ${getPercentMeaning(pricePercent)} o ${Math.abs(pricePercent)}% rok do roku.`,
            cheapestCities
                ? `Patrząc na miasta wojewódzkie, najtańsze mieszkania znajdziemy ${cityPronounWhere(cheapestCities[0].city)} ${cityNameWhere(cheapestCities[0].city)}, ${cityNameWhere(cheapestCities[1].city)} i ${cityNameWhere(cheapestCities[2].city)}. Ceny mieszkań wynoszą tu odpowiednio ${priceM2Format(cheapestCities[0].avgPriceM2)}, ${priceM2Format(cheapestCities[1].avgPriceM2)} oraz ${priceM2Format(cheapestCities[2].avgPriceM2)}`
                : "",
            expensiveCities
                ? `Najdroższym miastem pod względem cen mieszkań jest ${expensiveCities[0].city}. Na kolejnych miejscach plasują się: ${expensiveCities[1].city}, ${expensiveCities[2].city} i ${expensiveCities[3].city}.`
                : ""
        ];

        return [
            {
                name: "Ile kosztuje średnio metr kwadratowy mieszkania w Polsce?",
                answer: answers[0],
                answer_text: answers[0]
            },
            {
                name: "Gdzie są najtańsze mieszkania w Polsce?",
                answer: answers[1],
                answer_text: answers[1]
            },
            {
                name: "Gdzie są najdroższe mieszkania w Polsce?",
                answer: answers[2],
                answer_text: answers[2]
            }
        ];
    }, [cheapestCities, expensiveCities]);

    return (
        <>
            {((faq && faq.length > 0) || genericFaq) && (
                <Container css={mb(8)}>
                    <FaqSection
                        faqContent={faq}
                        genericFaqTitle="Pytania o ceny mieszkań w Polsce"
                        genericQuestions={genericFaq}
                        titleAlign="center"
                        css={faqStyle}
                    />
                </Container>
            )}
        </>
    );
};

const faqStyle = css`
    max-width: 100% !important;
`;
import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {mb} from "@pg-design/helpers-css";
import {FaqSection, IFaqQuestion} from "@pg-mono/faq";
import {monthWhenVerbose, priceFormat, priceM2Format} from "@pg-mono/string-utils";

import {IRPStore} from "../../../app/rp_reducer";
import {calculateAvgPrices} from "../utils/calculate_avg_prices";
import {cityNameWhere, cityPronounWhere} from "../utils/city_name_declination_utils";
import {getCitiesData} from "../utils/get_cities_data";
import {calculatePercent, getPercentMeaning, getPercentMoreLess} from "../utils/percents_handling_helpers";

export const PricesGeneralFAQ = () => {
    const faq = useSelector((store: IRPStore) => store.faq.data);
    const citiesSummaryData = getCitiesData();

    const cheapestCities = citiesSummaryData && [...citiesSummaryData].sort((prev, next) => prev.avgPriceM2 - next.avgPriceM2);
    const expensiveCities = citiesSummaryData && [...citiesSummaryData].sort((prev, next) => next.avgPriceM2 - prev.avgPriceM2);
    const date = new Date((citiesSummaryData && citiesSummaryData[0].date) || "");
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const {generalAvgPrice, generalAvgM2Price, generalOldAvgM2Price} = calculateAvgPrices(citiesSummaryData);
    const priceM2Percent = calculatePercent(generalOldAvgM2Price, generalAvgM2Price);
    const pricePercent = calculatePercent(generalOldAvgM2Price, generalAvgM2Price);

    const genericFaq: IFaqQuestion[] = useMemo(() => {
        const answers = [
            `W ${monthWhenVerbose(month)} ${year} średnia cena za m2 wynosi ${priceM2Format(generalAvgM2Price)}. To o ${Math.abs(priceM2Percent)}% ${getPercentMoreLess(priceM2Percent)} niż w ubiegłych roku. Średnia ofertowa cena mieszkania w Polsce wynosi aktualnie ${priceFormat(generalAvgPrice)}, to oznacza ${getPercentMeaning(pricePercent)} o ${Math.abs(pricePercent)}% rok do roku.`,
            cheapestCities
                ? `Patrząc na miasta wojewódzkie, najtańsze mieszkania znajdziemy ${cityPronounWhere(cheapestCities[0].city)} ${cityNameWhere(cheapestCities[0].city)}, ${cityNameWhere(cheapestCities[1].city)} i ${cityNameWhere(cheapestCities[2].city)}. Ceny mieszkań wynoszą tu odpowiednio ${priceM2Format(cheapestCities[0].avgPriceM2)}, ${priceM2Format(cheapestCities[1].avgPriceM2)} oraz ${priceM2Format(cheapestCities[2].avgPriceM2)}`
                : "",
            expensiveCities
                ? `Najdroższym miastem pod względem cen mieszkań jest ${expensiveCities[0].city}. Na kolejnych miejscach plasują się: ${expensiveCities[1].city}, ${expensiveCities[2].city} i ${expensiveCities[3].city}.`
                : ""
        ];

        return [
            {
                name: "Ile kosztuje średnio metr kwadratowy mieszkania w Polsce?",
                answer: answers[0],
                answer_text: answers[0]
            },
            {
                name: "Gdzie są najtańsze mieszkania w Polsce?",
                answer: answers[1],
                answer_text: answers[1]
            },
            {
                name: "Gdzie są najdroższe mieszkania w Polsce?",
                answer: answers[2],
                answer_text: answers[2]
            }
        ];
    }, [cheapestCities, expensiveCities]);

    return (
        <>
            {((faq && faq.length > 0) || genericFaq) && (
                <Container css={mb(8)}>
                    <FaqSection
                        faqContent={faq}
                        genericFaqTitle="Pytania o ceny mieszkań w Polsce"
                        genericQuestions={genericFaq}
                        titleAlign="center"
                        css={faqStyle}
                    />
                </Container>
            )}
        </>
    );
};

const faqStyle = css`
    max-width: 100% !important;
`;
